import React, {Component} from 'react'
import Sidebar from './common/sidebar_components/sidebar';
import Footer from './common/footer';
import Header from './common/header_components/header';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

export class App extends Component {
    render() {
        return (
            <div style={{fontFamily: 'DM Sans, sans-serif'}}>
                <div className="page-wrapper">
                    <Header request={(action, data, method = 'POST') => this.props.request(action, data, method)}/>
                    <div className="page-body-wrapper">
                        <Sidebar/>
                        <div className="page-body">
                            {this.props.children}
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        )
    }
}

export default App
